/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Confirm from './Confirm/index'
import ConfirmationCode from './ConfirmationCode/index'
import HappyToothGraphic from 'DesignSystem/Svgs/HappyToothGraphic/index'
import Info from 'DesignSystem/Info/index'
import OnboardingVerify from './OnboardingVerify/index'
import OtherContactMethods from './OtherContactMethods/index'
import React from 'react'
import ResendCodeAction from './ResendCodeAction/index'
import SentToContactMethod from './SentToContactMethod/index'
import SetPassword from './SetPassword/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content({
  children,
  viewPath = "/App/Auth/SignUpConfirm/Content"
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let signupConfirmRequestContactMethodTypeValueData = fromData.useDataValue({ viewPath,
context: 'signup_confirm_request',
path: 'contact_method_type',
})
let constantData = 'email'
let aggregateData = fromAggregate.equals(signupConfirmRequestContactMethodTypeValueData, constantData)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--o-2-Z1Yf8zk': isBefore ? 0 : 1,'--w-1-Z1Yf8zk': isMedia.mobile ? "100%" : "50%"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--w-1-Z1Yf8zk': isMedia.mobile ? "340px" : "360px"}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 style={{'--mr-3-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical2}`}
>
<HappyToothGraphic
  viewPath={`${viewPath}/HappyToothGraphic`}
 width={80}
 height={80}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 text="Practice Hub"
/>
</div>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text="Confirm Signup"
/>
<Info
  viewPath={`${viewPath}/Info`}
 marginTop={dtSpaceS}
 fontSize={16}
 text={aggregateData ? "We've sent an email with a verification code to:" : "We've sent an SMS with a verification code to:"}
 data="signup_confirm_request.contact_method_type"
 data="'email'"
 aggregate="/Simple/Data/aggregate.js equals"
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mt-4-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<SentToContactMethod
  viewPath={`${viewPath}/SentToContactMethod`}
/>
<OtherContactMethods
  viewPath={`${viewPath}/OtherContactMethods`}
/>
</div>
<ConfirmationCode
  viewPath={`${viewPath}/ConfirmationCode`}
/>
<SetPassword
  viewPath={`${viewPath}/SetPassword`}
/>
<Confirm
  viewPath={`${viewPath}/Confirm`}
/>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 style={{'--btc-5-Z1Yf8zk': dtColorsNeutral400}}
 className={`views-block ${styles.Horizontal2}`}
>
<Info
  viewPath={`${viewPath}/Info`}
 text="Didn't get the code?"
 marginRight={dtSpaceXxs}
 marginTop={dtSpaceS}
/>
<ResendCodeAction
  viewPath={`${viewPath}/ResendCodeAction`}
/>
</div>
<div
  data-testid="Content.Horizontal:3"
  data-view-path={viewPath}
 style={{'--mt-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal3}`}
>
<Info
  viewPath={`${viewPath}/Info`}
 text="Contact your clinic if you can't create the account."
 marginRight={dtSpaceXxs}
/>
</div>
</div>
</div>
<fromFlow.When is={!isMedia.mobile}>
<OnboardingVerify
  viewPath={`${viewPath}/OnboardingVerify`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}